'use client';

import CssBaseline from '@mui/material/CssBaseline';
import {
  type Theme,
  ThemeProvider as ThemeVarsProvider,
} from '@mui/material/styles';
import type { ThemeProviderProps as MuiThemeProviderProps } from '@mui/material/styles/ThemeProvider';

import type {} from '@infor/ui-lib/src/theme/extend-theme-types';

import { createTheme } from './create-theme';
import { themeConfig } from './theme-config';
import type { ThemeOptions } from './types';

export type ThemeProviderProps = Omit<MuiThemeProviderProps, 'theme'> & {
  theme?: Theme;
  themeOverrides?: ThemeOptions;
};

export const defaultSettingsAppInforcfc = {
  colorScheme: 'light' as 'light' | 'dark',
  direction: themeConfig.direction,
  contrast: 'default' as 'default' | 'hight',
  navLayout: 'vertical' as 'vertical' | 'horizontal',
  primaryColor: 'preset3' as
    | 'default'
    | 'preset1'
    | 'preset2'
    | 'preset3'
    | 'preset4'
    | 'preset5',
  navColor: 'apparent' as 'apparent' | 'integrate' | undefined,
  compactLayout: true,
  fontSize: 16,
  fontFamily: themeConfig.fontFamily.primary,
};

export function ThemeProvider({
  themeOverrides,
  children,
  ...other
}: ThemeProviderProps) {
  const theme = createTheme({
    settingsState: defaultSettingsAppInforcfc,
    localeComponents: {},
    themeOverrides,
  });

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      {children}
    </ThemeVarsProvider>
  );
}
